/* @generated from adl module ferovinum.sourcecontracts.carrier */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.carrier` contract.
 */
export interface CarrierSource {
  id: ferovinum_app_db.CarrierId;
  name: common_strings.StringNE;
  contactName: common_strings.StringNE;
  contactMobile: common_strings.StringNE;
  contactEmail: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeCarrierSource(
  input: {
    id: ferovinum_app_db.CarrierId,
    name: common_strings.StringNE,
    contactName: common_strings.StringNE,
    contactMobile: common_strings.StringNE,
    contactEmail: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): CarrierSource {
  return {
    id: input.id,
    name: input.name,
    contactName: input.contactName,
    contactMobile: input.contactMobile,
    contactEmail: input.contactEmail,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const CarrierSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.carrier","decl":{"annotations":[{"value":{"modelName":"source__app_db.carrier","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.carrier` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CarrierId"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactMobile","default":{"kind":"nothing"},"name":"contactMobile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"CarrierSource","version":{"kind":"nothing"}}};

export const snCarrierSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.carrier", name:"CarrierSource"};

export function texprCarrierSource(): ADL.ATypeExpr<CarrierSource> {
  return {value : {typeRef : {kind: "reference", value : snCarrierSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.carrier.CarrierSource" : CarrierSource_AST
};
